import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { Trophy } from 'lucide-react';
import PlayerCard from '../components/PlayerCard';
import api from '../../../services/api';

const TopRanking = () => {
  const { ref, inView } = useInView({
    threshold: 0.2,
    triggerOnce: true
  });

  const [topPlayers, setTopPlayers] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchRanking = async () => {
      try {
        const response = await api.get('/public/top-ranking');
        const data = response.data.ranking || response.data.data || response.data.characters || [];
        setTopPlayers(Array.isArray(data) ? data : []);
      } catch (error) {
        console.error('Erro ao carregar ranking:', error);
        // Dados de exemplo para fallback
        setTopPlayers([]);
      } finally {
        setLoading(false);
      }
    };

    if (inView) {
      fetchRanking();
    }
  }, [inView]);

  return (
    <section ref={ref} className="py-20 bg-gradient-to-br from-blue-900 via-blue-800 to-blue-900 relative overflow-hidden">
      {/* Background decoration */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-0 left-0 w-96 h-96 bg-cyan-400 rounded-full filter blur-3xl"></div>
        <div className="absolute bottom-0 right-0 w-96 h-96 bg-blue-400 rounded-full filter blur-3xl"></div>
      </div>

      <div className="container mx-auto px-4 relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <div className="flex justify-center mb-4">
            <div className="w-20 h-20 bg-gradient-to-br from-yellow-400 to-yellow-600 rounded-full flex items-center justify-center shadow-2xl">
              <Trophy className="w-10 h-10 text-white" />
            </div>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
            Hall da <span className="text-yellow-400">Fama</span>
          </h2>
          <p className="text-xl text-blue-200">
            Os personagens mais dedicados do Revolution
          </p>
        </motion.div>

        {loading ? (
          <div className="flex overflow-x-auto gap-6 pb-6 snap-x snap-mandatory scrollbar-hide lg:grid lg:grid-cols-5 lg:overflow-visible">
            {[1, 2, 3, 4, 5].map((i) => (
              <div key={i} className="min-w-[280px] flex-shrink-0 snap-center lg:min-w-0 bg-white rounded-lg overflow-hidden animate-pulse">
                <div className="h-24 bg-gray-300"></div>
                <div className="p-6 space-y-3">
                  <div className="h-20 w-20 bg-gray-300 rounded-full mx-auto"></div>
                  <div className="h-4 bg-gray-300 rounded"></div>
                  <div className="h-3 bg-gray-200 rounded w-2/3 mx-auto"></div>
                </div>
              </div>
            ))}
          </div>
        ) : !topPlayers || topPlayers.length === 0 ? (
          <div className="text-center text-blue-200 py-12">
            <p className="text-xl">Ranking em breve...</p>
          </div>
        ) : (
          <div className="relative">
            {/* Scroll indicator for mobile */}
            <div className="lg:hidden text-center mb-4">
              <p className="text-blue-300 text-sm animate-pulse">
                👈 Deslize para ver mais →
              </p>
            </div>
            
            <div className="flex overflow-x-auto gap-6 pb-6 snap-x snap-mandatory scrollbar-hide lg:grid lg:grid-cols-5 lg:overflow-visible">
              {topPlayers.map((player, index) => (
                <div key={player.id} className="min-w-[280px] flex-shrink-0 snap-center lg:min-w-0">
                  <PlayerCard 
                    player={player} 
                    rank={index + 1}
                    index={index}
                  />
                </div>
              ))}
            </div>
          </div>
        )}

        <motion.div
          initial={{ opacity: 0 }}
          animate={inView ? { opacity: 1 } : {}}
          transition={{ delay: 0.8 }}
          className="mt-12 text-center"
        >
          <p className="text-blue-200 text-lg">
            Será que você consegue chegar ao topo? 🏆
          </p>
        </motion.div>
      </div>
    </section>
  );
};

export default TopRanking;
